import { connect } from 'react-redux';
import { InfiniteProducts } from './infinite-products';
import { infiniteProductsSelector } from './connect/infinite-products.selectors';
export default connect(infiniteProductsSelector)(InfiniteProducts);